/** Artifact positions — edit view (delegates to the shared form). */
import { ArtifactPositionForm } from "./_ArtifactPositionForm";

export function ArtifactPositionEdit() {
  return <ArtifactPositionForm action="edit" />;
}

export default ArtifactPositionEdit;
